// extracted by mini-css-extract-plugin
module.exports = {"AdSlotOffsite":"bgg_a bhc_bi"};